import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { ConnectorSidebar } from './ConnectorSidebar'
import { ConnectorHeader } from './ConnectorHeader'

export function ConnectorLayout() {
  const [navOpen, setNavOpen] = useState(false)

  return (
    <div className="h-screen flex bg-gray-50 overflow-hidden">
      {/* Sidebar */}
      <ConnectorSidebar open={navOpen} onClose={() => setNavOpen(false)} />

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        {/* Header */}
        <ConnectorHeader onOpenNav={() => setNavOpen(true)} />

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto overflow-x-hidden">
          <div className="p-4 sm:p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}